import { Step } from 'react-joyride';

const SubscriptionsTourSteps: Step[] = [
  {
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a la sección de <strong>Suscripción</strong>. Aquí puedes
        consultar el plan activo de tu empresa, ver los planes que estarán
        disponibles y descargar tus comprobantes.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-current-plan',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este bloque muestra los <strong>detalles de tu plan actual</strong>: el
        precio que pagas, el estado de la suscripción, la fecha de inicio y si
        tienes la renovación automática activada.
      </div>
    ),
    placement: 'top',
  },
  {
    target: '.tour-plan-catalog',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es el <strong>catálogo de planes</strong> que entrarán en vigor en
        2027. Cada tarjeta muestra su precio y puedes desplegar el detalle de
        las funcionalidades incluidas. Durante el período de lanzamiento todos
        son gratuitos.
      </div>
    ),
    placement: 'top',
  },
  {
    target: '.tour-comprobantes',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí encontrarás tus <strong>comprobantes</strong>, que puedes
        descargar en cualquier momento. Ten en cuenta que no constituyen
        facturas fiscales.
      </div>
    ),
    placement: 'top',
  },
];

export default SubscriptionsTourSteps;